__webpack_require__.p = "https://qrscan-a3a.pages.dev/";